import { Box, Flex, Image, Text } from "@chakra-ui/react";
import HeaderCell from "components/table/HeaderCell";

const getStatusColor = (status) => {
  switch (status) {
    case "Live":
      return "#00FF3829";
    case "Pending":
      return "#FF000029";
    case "Rejected":
      return "#B92C5329";
    case "Sold":
      return "#5450A329";
    default:
      return "gray.100";
  }
};

const getStatusTextColor = (status) => {
  switch (status) {
    case "Live":
      return "#00FF38";
    case "Pending":
      return "#FF0000";
    case "Rejected":
      return "#B92C53";
    case "Sold":
      return "#5450A3";
    default:
      return "gray.100";
  }
};

const columns = [
  {
    name: <HeaderCell label={"BALANCE ID"} />,
    selector: (row) => row?.id,
     width: '150px'
  },
  {
    name: <HeaderCell label={"SKU"} />,
    selector: (row) => {
      const variants = row?.transaction_id?.product_id?.variants;
      const variantId = row?.transaction_id?.variant_id;
  
      if (!variants || !variantId) return "-";
  
      const matchedVariant = variants.find(v => v._id === variantId);
      return matchedVariant?.sku || "-";
    },
    width: "150px",
  },  
  {
    name: <HeaderCell label={"PRODUCT TITLE"} />,
    selector: (row) => row?.transaction_id?.product_id?.product_title || "-",
    width: "450px",
  },
  
  {
    name: <HeaderCell label={'DATE'} />,
    selector: row => {
      if (!row?.date_created) return '';
      const date = new Date(row.date_created);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    width: '200px'
  },
  
  {
    name: <HeaderCell label={'TRANSACTION TYPE'} />,
    selector: row => {
      const name = row?.transaction_id?.transaction_type_id?.name;
      switch (name) {
        case 'return-cost':
          return 'Return Cost';
        case 'seller-commission':
          return 'Seller Commission';
        case 'seller_commission':
          return 'Seller Commission';
        case 'dry-cleaning-cost':
          return 'Dry Cleaning Cost';
        case 'dry-cleaning-cost-removed':
          return 'Dry Cleaning Cost Removed';
        case 'payment':
          return 'Payment Received';
        case 'refund':
          return 'Refunded';
        default:
          return name;
      }
    },
    width: '300px',
  },  
  {
  name: <HeaderCell label={"AMOUNT"} />,
  selector: (row) => {
    const type = row?.transaction_id?.transaction_type_id?.name;
    const amount = row?.amount ?? 0;

    // If type is NOT seller-commission → make it negative
    if (type !== "seller-commission" && type !== "seller_commission" && type !== "dry-cleaning-cost-removed" && type !== "dry-cleaning-cost-removed") {
      return `-£${Math.abs(amount).toFixed(2)}`;
    }

    // Otherwise (seller-commission) → keep it positive
    return `£${Number(amount).toFixed(2)}`;
  },
  width: '200px',
},

  // {
  //   name: <HeaderCell label={'BALANCE'} />,
  //   selector: row => {
  //     const balance = row?.balance_after ?? 0;
  //     const displayBalance = Math.abs(balance);
  
  //     if (balance < 0) {
  //       // Negative balance
  //       return (
  //         <Flex alignItems={'center'} gap={1}>
  //           <Text color={'#FF0000'}>£{displayBalance}</Text>
  //           <Image
  //             width={5}
  //             height={5}
  //             src={require('../../assets/svgs/ArrowDownNegative.svg').default}
  //             _hover={{ cursor: 'pointer' }}
  //           />
  //         </Flex>
  //       );
  //     }
  
  //     // Positive balance
  //     return (
  //       <Flex alignItems={'center'} gap={1}>
  //         <Text color={'#00B85E'}>£{displayBalance}</Text>
  //         <Image
  //           width={5}
  //           height={5}
  //           src={require('../../assets/svgs/Arrow.svg').default}
  //           _hover={{ cursor: 'pointer' }}
  //         />
  //       </Flex>
  //     );
  //   },
  //   width: '200px',
  // }
  
  // {
  //   name: <HeaderCell label={"PAYMENT STATUS"} />,
  //   selector: (row) => row.payment_status,
  //   cell: (row) => (
  //     <span
  //       style={{
  //         backgroundColor: getStatusColor(row.payment_status),
  //         color: getStatusTextColor(row.payment_status),
  //         padding: "5px 10px",
  //         fontSize: "16px",
  //         fontWeight: "400",
  //         borderRadius: "50px",
  //         width: "140px",
  //         textAlign: "center",
  //         fontFamily: "PlusJakartaSansRegular",
  //       }}
  //     >
  //       {row.payment_status}
  //     </span>
  //   ),
  // },
  // {
  //   name: <HeaderCell label={"ACTION"} />,
  //   selector: (row) => row.action,
  //   width: "120px",
  // },
];

const data = [
  {
    paymentId: "001234",
    paymentDate: "12 Jan 2025",
    amount: "£3.95",
    balance: "£13,200",
    balanceChange: "down",
  },
  {
    paymentId: "001235",
    paymentDate: "12 Jan 2025",
    amount: "£2.95",
    balance: "£13,200",
    balanceChange: "down",
  },
  {
    paymentId: "001236",
    paymentDate: "12 Jan 2025",
    amount: "£200",
    balance: "£22,450",
    balanceChange: "up",
  },
  {
    paymentId: "001237",
    paymentDate: "12 Jan 2025",
    amount: "£3.95",
    balance: "£10,000",
    balanceChange: "down",
  },
  {
    paymentId: "001238",
    paymentDate: "12 Jan 2025",
    amount: "£3.95",
    balance: "£15,750",
    balanceChange: "up",
  },
];

export { data, columns };
